<template>
  <v-skeleton-loader
    v-if="loading"
    type="table"
  />
  <v-card
    v-else
  >
    <v-card-title>
      Select presentation time length
    </v-card-title>
    <v-card-text>
      <p>
        The total includes {{ breakCount }} breaks of
        <MinutesToHours
          :minutes="breakMinutes"
        />
        / a
        <MinutesToHours
          :minutes="lunchMinutes"
        />
        lunch break /
        <SecondsToMinutes
          :seconds="bufferSeconds"
        />
        between presentations.
      </p>

      <v-data-table
        v-model="selectedOption"
        :headers="headers"
        :items="options"
        item-key="presentationTimeSeconds"
        single-select
        show-select
      >
        <template v-slot:item.presentationTimeSeconds="{ item }">
          <SecondsToMinutes
            :seconds="item.presentationTimeSeconds"
          />
        </template>
        <template v-slot:item.totalTimeMinutes="{ item }">
          <MinutesToHours
            :minutes="item.totalTimeMinutes"
          />
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-btn
        @click="submit"
      >
        Submit presentation time
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import AdminClient from '@/api/AdminClient';
import SecondsToMinutes from '@/components/SecondsToMinutes.vue';
import MinutesToHours from '@/components/MinutesToHours.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'AdminPresentationTime',
  components: {
    SecondsToMinutes,
    MinutesToHours,
  },
  data() {
    return {
      eventId: null,
      lunchMinutes: null,
      breakCount: null,
      breakMinutes: null,
      bufferSeconds: null,
      options: [],
      selectedOption: null,
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      currentJwtToken: 'currentJwtToken',
      currentUser: 'currentUser',
    }),
    headers() {
      return [
        { text: 'Presentation Time', value: 'presentationTimeSeconds' },
        { text: 'Total Time', value: 'totalTimeMinutes' },
      ];
    },
  },
  mounted() {
    this.eventId = this.$store.state.hackathonID || null;
    this.adminClient = new AdminClient(this.currentJwtToken);
    this.getScheduleOptions();
  },
  methods: {
    ...mapActions({
      setPresentationTime: 'setPresentationTime',
    }),
    async getScheduleOptions() {
      const response = await this.adminClient.getScheduleOptions(this.eventId);
      this.lunchMinutes = response.lunchMinutes;
      this.breakMinutes = response.breakMinutes;
      this.breakCount = response.breakCount;
      this.bufferSeconds = response.presentationBufferSeconds;
      this.options = response.options;
      this.loading = false;
    },
    async submit() {
      this.loading = true;
      // data tables support multiple selections, so it's an array
      const seconds = this.selectedOption[0].presentationTimeSeconds;
      await this.adminClient.setPresentationTime(this.eventId, seconds);
      this.setPresentationTime(seconds);
    },
  },
};
</script>
